export const ICONS_VERSION = "1708287250252";
export const ICON_SPRITE = "/icons-generated/_icon-sprite.svg";
